module.exports = __webpack_public_path__ + "static/media/Restaurant.d1edb3d4.svg";